var React = require('react');

function IconHardrock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.72,22.83l-3.45-6.06a1.36,1.36,0,0,0-2.51,0l-.94,1.67L18.66,7.89a1.36,1.36,0,0,0-1.25-.84,1.48,1.48,0,0,0-1.25.84l-5.43,9.4-2.3-4.18a1.61,1.61,0,0,0-1.25-.84,1.47,1.47,0,0,0-1.25.84L.27,22.83a1.48,1.48,0,0,0-.1,1.46,1.44,1.44,0,0,0,1.36.63H30.47a1.55,1.55,0,0,0,1.36-.63,1.27,1.27,0,0,0-.1-1.46h0M17.41,8.62l3.34,5.85L20,15.2l-1.78-1.46a1.13,1.13,0,0,0-1.57.1L14.89,16l-1.25-.73L17.4,8.62h0M7.16,13.84,10,18.76l-2.4,4.08a2,2,0,0,0-.21.73H1.52l5.64-9.72h0m1.67,9.72,4.08-7,1.46.94a1.48,1.48,0,0,0,.63.21,1.14,1.14,0,0,0,.94-.42l1.78-2.09,1.67,1.36a1.27,1.27,0,0,0,1.67-.1l.63-.63,4.49,7.73H8.84m18.71,0a2,2,0,0,0-.21-.73L25.66,19.9,27,17.5l3.45,6.06H27.54","transform":"translate(-0.02 -7.05)"}));
}

IconHardrock.defaultProps = {"width":"20px","height":"12px","className":"icon","viewBox":"0 0 32 17.87"};

module.exports = IconHardrock;

IconHardrock.default = IconHardrock;
